import { HttpClient } from '@angular/common/http';
import { inject, Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { ReplaySubject, firstValueFrom, lastValueFrom } from 'rxjs';
import { HubService } from './hub.service';
import { Auth } from '@angular/fire/auth';
import { PaymentData } from '../model/common.model';
import { LoyaltyService } from './loyalty.service';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class ActionLogService {
  private http = inject(HttpClient); 
  constructor() {
  }

  search(criteria?: any) {
    return firstValueFrom(this.http.post<{ List: any[], Total: number }>('/api/actionlog/search', criteria || {}));
  }

}
